/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';

import {InternalFormsSharedModule, REACTIVE_DRIVEN_DIRECTIVES, TEMPLATE_DRIVEN_DIRECTIVES} from './directives';
import {RadioControlRegistry} from './directives/radio_control_value_accessor';
import {FormBuilder} from './form_builder';
/**
 * The ng module for forms.
 * \@stable
 */
export class FormsModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: TEMPLATE_DRIVEN_DIRECTIVES,
  providers: [RadioControlRegistry],
  exports: [InternalFormsSharedModule, TEMPLATE_DRIVEN_DIRECTIVES]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function FormsModule_tsickle_Closure_declarations() {
/** @type {?} */
FormsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FormsModule.ctorParameters;
}

/**
 * The ng module for reactive forms.
 * \@stable
 */
export class ReactiveFormsModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [REACTIVE_DRIVEN_DIRECTIVES],
  providers: [FormBuilder, RadioControlRegistry],
  exports: [InternalFormsSharedModule, REACTIVE_DRIVEN_DIRECTIVES]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ReactiveFormsModule_tsickle_Closure_declarations() {
/** @type {?} */
ReactiveFormsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ReactiveFormsModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
